import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../helpers';
import { AppContextProvider } from '../../../Services/AppContext';
import { store } from '../../../store/store';
import AclContextProvider from '../../Acl/Components/AclContextProvider';
import WorkplaceDoctorStatisticsModalButton from './WorkplaceDoctorStatisticsModalButton';
import netteApiClient from '../../../Services/NetteApiClient';

loadDOMComponent({
	selector: 'react-workplace-doctor-statistics-modal-button',
	callback: ({ container, context }: any) => {
		const url = container.getAttribute('url');

		const handleClick = () => {
			netteApiClient.get(url);
		};

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<WorkplaceDoctorStatisticsModalButton onClick={handleClick} />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
